import type { ChartColor } from '@terrazzo/core'

const HATCHED: ChartColor[] = ['ink', 'gray', 'peach', 'sand', 'chartreuse', 'sage', 'azure', 'sky', 'lilac', 'rose', 'slate']
/**
 * The hatching every chart (and the day's strip in Time) draws what's still open with: thin, light
 * lines of the color over a faint wash of it, light enough that words on it read plainly. Drawn once for the whole app; charts fill with `dim()`.
 */
export function ChartDefs() {
  return (
    <svg width="0" height="0" className="absolute" aria-hidden="true" focusable="false">
      <defs>
        {HATCHED.map((c) => (
          <pattern key={c} id={`tz-hatch-${c}`} patternUnits="userSpaceOnUse" width="4.5" height="4.5" patternTransform="rotate(45)">
            {/* The wash is see-through, so hatching sits right on any card, panel or page. */}
            <rect width="4.5" height="4.5" style={{ fill: `color-mix(in srgb, var(--c-${c}) 5%, transparent)` }} />
            <rect width="1.25" height="4.5" style={{ fill: `color-mix(in srgb, var(--c-${c}) 11%, transparent)` }} />
          </pattern>
        ))}
      </defs>
    </svg>
  )
}
